/**
 * accountQr — Code QR unique par compte, lié à l'id en base.
 *
 * Format normalisé : zifek://account/{type}/{id}
 *  - type : 'merchant' | 'client' | 'vendeur' | 'customer'
 *  - id   : identifiant en base (users.id ou credit_customers.id)
 *
 * Le scan permet ensuite d'ouvrir le profil / d'initier une transaction.
 */

export type AccountQrType = 'merchant' | 'client' | 'vendeur' | 'customer';

export interface AccountQrPayload {
  type: AccountQrType;
  id: number;
}

const ACCOUNT_QR_RE = /zifek:\/\/account\/([a-z]+)\/(\d+)/i;

/** Construit la donnée encodée dans le QR d'un compte. */
export function buildAccountQrData(type: AccountQrType, id: number): string {
  return `zifek://account/${type}/${id}`;
}

/** Extrait un compte depuis un contenu de QR scanné. */
export function parseAccountQrData(data: string): AccountQrPayload | null {
  const match = data.match(ACCOUNT_QR_RE);
  if (!match) return null;
  const type = match[1].toLowerCase() as AccountQrType;
  const id = parseInt(match[2], 10);
  if (Number.isNaN(id)) return null;
  return { type, id };
}

/** URL publique liée à un compte (partage en ligne). */
export function buildAccountQrUrl(origin: string, type: AccountQrType, id: number): string {
  if (type === 'merchant' || type === 'vendeur') return `${origin}/credit/join?merchant=${id}`;
  return `${origin}/credit`;
}